import React from "react";
import "../styles/Footer.css";
import logo from '../assets/GeoParking.png';
import { FaLinkedin, FaYoutube, FaFacebook, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        {/* Left Section */}
        <div className="footer-left">
          <a href="/home">
          <img src={logo} alt="GeoParking Technologies" className="footer-logo" />
          </a>
          <h2 className="footer-tagline">
            Powering the Future of<br />Autonomous Parking.
          </h2>
          <p className="footer-description">
            GeoParking connects property owners with Robotaxi operators through an AI-powered platform that simplifies parking management, maximizes efficiency, and unlocks new revenue opportunities.
          </p>
          <div className="footer-socials">
            <a href="https://www.linkedin.com/company/GeoParking/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
            <a href="https://www.facebook.com/geoparkingtech" target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </a>
                        <a href="https://www.instagram.com/geoparkingtech" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
                        <a href="https://x.com/GeoParkingTech" target="_blank" rel="noopener noreferrer">
              <FaXTwitter />
            </a>
            <a href="https://www.youtube.com/@GeoParkingTech" target="_blank" rel="noopener noreferrer">
              <FaYoutube />
            </a>
          </div>
        </div>

        {/* Center Section */}
        <div className="footer-center">
          <h2>Explore</h2>
          <a href="/home">Home</a>
          <a href="/product-and-service">Product & Services</a>
          <a href="/mission-statement">Company Values</a>
          <a href="/support" target="_blank">Support</a>
        </div>

        {/* Right Section */}
        <div className="footer-right">
          <h2>Resources</h2>
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms-of-use">Website Terms of Use</a>
          <a href="/terms-of-service">Parking Lot Management Terms of Service</a>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <span className="left">© 2025 GeoParking Technologies, Inc. All rights reserved.</span>
        <span className="right">Driving smarter mobility — one parking space at a time.</span>
      </div>
    </footer>
  );
};

export default Footer;
